<template>
    <div class="text-white relative h-16 border-b border-darkgray max-w-2xl mx-auto w-full focus-within:border-pink">
        <input
            autofocus
            class="h-full w-full pl-11 bg-transparent focus:outline-none"
            type="search"
            placeholder="Search"
            v-model="inputValue"
        >
        <AtomIcSearch :width="38" class="absolute stroke-darkgray left-0 top-1/2 transform -translate-y-1/2" />
    </div>
</template>

<script>
import AtomIcSearch from "../atoms/AtomIcSearch.vue";

export default {
    name: "MoleculeSearchInput",
    components: {AtomIcSearch},
    props: {
        value: String
    },
    data() {
        return {
            inputValue: this.value
        };
    },
    watch: {
        inputValue(newValue) {
            this.$emit("input", newValue);
        }
    }
}
</script>

<style scoped></style>
